import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Icon } from '../icon/icon.component';
import { Select } from '../select/select.component';
import { SelectOption } from '../select-option/select-option.component';
import { type Style, mergeStyle } from './pagination.module.css';

interface Props {
  count: number;
  index: number;
  size: number;
  pages: number;
  title: string;
  style?: Style;
  onChange: (page: number, size: number) => Promise<void> | void;
}

export function Pagination(props: Props) {

  const {
    index,
    size: initialSize,
    count,
    pages,
    title,
    style: customStyle,
    onChange
  } = props;

  const style = mergeStyle(customStyle);
  const [size, setSize] = useState(initialSize);
  const [loading, setLoading] = useState<boolean>(false);

  const sizes = [1000, 100, 50, 25, 10];
  const disabledPrevButton = index === 1 || loading;
  const disabledNextButton = index >= pages || loading;

  useEffect(() => {
    setSize(initialSize);
  }, [initialSize]);

  function handlePrevious() {
    handleChange(index - 1, size);
  }

  function handleNext() {
    handleChange(index + 1, size);
  }

  function handleSize(value?: number) {
    setSize(value!);
    handleChange(1, value!);
  }

  async function handleChange(index: number, size: number) {
    try {
      setLoading(true);
      await onChange(index, size);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={style.container}>
      <div className={style.content}>
        <div className={style.count}>{count} {title}</div>
        <div className={style.size}>
          <div>Cantidad</div>
          <Select 
            style={style.select}
            value={size}
            valueTitle={size.toString()}
            disabled={loading}
            onChange={handleSize}>
            {sizes.map(size => 
              <SelectOption
                key={size} 
                style={style.selectOption} 
                label={size.toString()} 
                value={size} 
                showClearIcon={false}>
                {size}
              </SelectOption>
            )}
          </Select>
        </div>
        <div className={style.page}>
          <div>Página</div>
          <Icon
            className={clsx(style.icon, disabledPrevButton && style.iconDisabled)} 
            icon='navigate_before'
            onClick={handlePrevious}/>
          <div>{index}</div>
          <Icon
            className={clsx(style.icon, disabledNextButton && style.iconDisabled)}
            icon='navigate_next'
            onClick={handleNext}/>
          <div>de &nbsp;{pages}</div>
        </div>
      </div>
    </div>
  );
}
